import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  ...stateAbstract,
  documentsDetail: {},
  documentsCount: null,
  documentsList: [],
  'submission-requestsDetail': {},
  'submission-requestsCount': null,
  'submission-requestsList': [],
  rulesDetail: {},
  rulesCount: null,
  rulesList: []
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
